import { SadieDashboardStat, SadieStatChange, SadieStatFormat } from "@/types";

const PERCENT = 100;
const DECIMAL_BASE = 10;

// A share as percentage points, rounded to the given decimals.
const toPoints = (share: number, decimals: number): number => {
  const factor = DECIMAL_BASE ** decimals;
  return Math.round(share * PERCENT * factor) / factor;
};

export const sadieDashboard = {
  // Decimals apply to a rate only, for small ones like an opt-out rate that
  // would otherwise all round to the same whole percent.
  formatValue: (
    stat: SadieDashboardStat,
    format: SadieStatFormat,
    decimals = 0,
  ): string =>
    format === SadieStatFormat.RATE
      ? `${toPoints(stat.value, decimals).toFixed(decimals)}%`
      : stat.value.toLocaleString(),

  // "61 of 148" under a rate, so a big swing on a few workers reads as such.
  formatCounts: (stat: SadieDashboardStat): string | null => {
    if (stat.numerator === undefined || stat.denominator === undefined) {
      return null;
    }
    return `${stat.numerator.toLocaleString()} of ${stat.denominator.toLocaleString()}`;
  },

  // Null when there is no earlier window to compare against.
  change: (
    stat: SadieDashboardStat,
    format: SadieStatFormat,
    decimals = 0,
  ): SadieStatChange | null => {
    if (stat.previousValue === null) return null;
    const isRate = format === SadieStatFormat.RATE;
    const amount = isRate
      ? toPoints(stat.value - stat.previousValue, decimals)
      : stat.value - stat.previousValue;
    const sign = amount > 0 ? "+" : "";
    const formatted = isRate
      ? amount.toFixed(decimals)
      : amount.toLocaleString();
    const unit = isRate ? " pts" : "";
    return { amount, label: `${sign}${formatted}${unit}` };
  },
};
